"use strict";
document.addEventListener('DOMContentLoaded', function () {
    const quantityOptions = document.querySelectorAll('.quantity__option');
    const quantityInputs = document.querySelectorAll('input[data-quantity-input]');

    function updateOrgPrice(price) {
        const orgPriceElem = document.querySelectorAll('.original-price');
        if (!orgPriceElem) return;
        orgPriceElem.forEach((elem) => {
            elem.textContent = price;
        })
    }

    function updatePrice(quantity, quantityInput) {
        const selectedOption = document.querySelector('.quantity__option.selected[data-discount]');
        const basePrice = parseFloat(quantityInput.dataset.price) / 100;
        let totalPrice = basePrice * quantity;
        const orgMoneyFormat = Shopify.formatMoney(totalPrice * 100, window.money_format);
        
        let discountPercentage = 0;
        if (window.discountPercentageType && window.discountPercentageType.trim() === 'manual') 
        {
            if (window.discountEnabled === 'true' && !!window.discountsData) {
                discountPercentage = window.discountsData.find((data) => parseInt(data.quantity) === quantity)?.discount;
                const isDiscountInvalid = Number.isNaN(parseInt(discountPercentage));
                const highestDiscount = window.discountsData.at(-1);
                
                if (isDiscountInvalid) {
                    discountPercentage = '0';
                }
                
                if (quantity > parseInt(highestDiscount?.quantity)) {
                    discountPercentage = highestDiscount?.discount;
                }

                discountPercentage = parseInt(discountPercentage);
            } else {
                discountPercentage = 0;
            }

            if (discountPercentage > 0) {
                updateOrgPrice(orgMoneyFormat)
            } else {
                updateOrgPrice("")
            }
            totalPrice = totalPrice * (1 - discountPercentage / 100);
        }
        else {
            // Automatic discount logic
            discountPercentage = parseFloat(quantityInput.dataset.discountPercentage) || 10;
            if (quantity > 1) {
                const discountStep = quantity - 1;
                const currentDiscount = discountStep * discountPercentage;
                totalPrice = totalPrice * (1 - currentDiscount / 100);
            }
        }
        const moneyFormat = Shopify.formatMoney(totalPrice * 100, window.money_format);
        const priceElement = document.querySelector('.price--medium .price__regular .price-item--regular');
        if (priceElement)
            priceElement.textContent = moneyFormat;
        const subtotalElement = document.querySelector('.productView-subtotal .money-subtotal');
        if (subtotalElement)
            subtotalElement.textContent = moneyFormat;
        const stickyPrice = document.querySelector('[data-sticky-add-to-cart] .money-subtotal');
        if (stickyPrice)
            stickyPrice.textContent = moneyFormat;
        // Update hidden input value
        // quantityInput.value = quantity;
        quantityInputs.forEach(input => {
            input.value = quantity;
        });
    }
    // Handle quantity options (stacked style)
    quantityOptions.forEach(option => {
        option.addEventListener('click', function () {
            const quantity = parseInt(this.dataset.quantity);
            // Remove 'selected' class from all options
            document.querySelectorAll('.quantity__option[data-quantity]').forEach(opt => {
                opt.classList.toggle('selected', opt.dataset.quantity === String(quantity));
            });
            // Update all quantity inputs
            quantityInputs.forEach(input => {
                input.value = quantity;
            });
            if (quantityInputs.length > 0) {
                updatePrice(quantity, quantityInputs[0]);
                quantityInputs[0].dispatchEvent(new Event('change'));
            }
        });
    });
    // Handle quantity input changes (manual input)
    quantityInputs.forEach(input => {
        input.addEventListener('change', function () {
            const quantity = parseInt(this.value);
            if (quantity > 0) {
                updatePrice(quantity, this);
            }
        });
    });
    // Recompute the stacked bundle option cards (1/2/3 product cards) when the
    // selected variant changes, so each card reflects the new variant price.
    function getVariantPriceById(variantId) {
        const dataEl = document.querySelector('.product-option [type="application/json"], variant-selects [type="application/json"], variant-radios [type="application/json"]');
        if (!dataEl)
            return null;
        let variants;
        try {
            variants = JSON.parse(dataEl.textContent);
        }
        catch (e) {
            return null;
        }
        const variant = Array.isArray(variants)
            ? variants.find(v => String(v.id) === String(variantId))
            : null;
        return variant ? variant.price : null;
    }
    function getDiscountForQuantity(index, container) {
        if (window.discountPercentageType && window.discountPercentageType.trim() === 'manual') {
            if (index === 1)
                return parseFloat(window.discountPercentage1) || 0;
            if (index === 2)
                return parseFloat(window.discountPercentage2) || 0;
            return 0;
        }
        const input = (container && container.parentElement && container.parentElement.querySelector('[data-quantity-input]'))
            || document.querySelector('[data-quantity-input]');
        const baseDiscount = input ? (parseFloat(input.dataset.discountPercentage) || 0) : 0;
        return (quantity - 1) * baseDiscount;
    }
    function updateBundleOptionPrices(unitCents) {
        if (unitCents == null)
            return;
        const isManual = window.discountPercentageType && window.discountPercentageType.trim() === 'manual';
        document.querySelectorAll('quantity-options').forEach(container => {
            container.querySelectorAll('.quantity__option').forEach((option, index) => {
                const quantity = parseInt(option.dataset.quantity) || 1;
                const discount = getDiscountForQuantity(index, container);

                // Match the server-side Liquid rounding (integer cents, floored discount).
                const perItem = unitCents - Math.floor(unitCents * discount / 100);
                const oldTotal = unitCents * quantity;
                const saleTotal = isManual
                    ? perItem * quantity
                    : oldTotal - Math.floor(oldTotal * discount / 100);

                option.querySelectorAll('[data-bundle-role]').forEach(el => {
                    const role = el.dataset.bundleRole;
                    let cents = saleTotal;
                    if (role === 'old')
                        cents = oldTotal;
                    else if (role === 'unit')
                        cents = perItem;
                    el.textContent = Shopify.formatMoney(cents, window.money_format);
                });
            });
        });
    }
    document.addEventListener('change', function (event) {
        const target = event.target;
        if (!target || !target.matches || !target.matches('input[name="id"]'))
            return;
        const price = getVariantPriceById(target.value);
        if (price == null)
            return;
        // Keep the hidden quantity input in sync so per-option clicks compute correctly.
        quantityInputs.forEach(input => { input.dataset.price = price; });
        updateBundleOptionPrices(price);
        // Re-sync the main/subtotal price for the currently selected quantity.
        const selectedOption = document.querySelector('.quantity__option.selected[data-quantity]');
        if (selectedOption && quantityInputs.length > 0) {
            updatePrice(parseInt(selectedOption.dataset.quantity) || 1, quantityInputs[0]);
        }
    });
    // Set default selected quantity
    const defaultQuantity = 1;
    document.querySelectorAll(`.quantity__option[data-quantity="${defaultQuantity}"]`).forEach(opt => {
        opt.classList.add('selected');
    });
    if (quantityInputs.length > 0) {
        updatePrice(defaultQuantity, quantityInputs[0]);
    }
});
//# sourceMappingURL=quantity-handler.js.map
